module.exports = __webpack_public_path__ + "static/Gotham-Bold-d9b5b981b543ec391a72248eb15d5c5d.woff";